import React from 'react'
import PropTypes from 'prop-types';
import './index.scss'

const LightList = (props) => {
  const {
    data
  } = props
  let dataList = data.split('\n')
  return (
    <div className='lightListBox' data-type='discountQuoteInfo'>
      {
        dataList.map((item, index) => {
          return (
            <div className='lightItem' key={'item' + index}>{item}</div>
          )
        })
      }
    </div>
  )
}

LightList.propTypes = {
  data: PropTypes.string
}
export default LightList